import { call, put, takeEvery, select } from 'redux-saga/effects';

import Actions from '../action';
import Axios from 'axios';
import { API_DOMAIN, CAMPANY } from '@constants/app-constants';
import { message } from 'antd';
const getToken = (state) => state.WelcomePage;

export function* getDeliveryInfoServiceWorker(action) {
	try {
		// let companyId = CAMPANY.Id;
		const token = yield select(getToken);
		let companyId = action.companyId;
		const uri = `${API_DOMAIN}/CardDeliveryAddress/` + companyId;
		let res = yield call(Axios.get, uri);
		yield put(Actions.creators.getDeliveryInfoSuccess(res));
	} catch (err) {
		message.error('Network Error');
		yield put(Actions.creators.getDeliveryInfoError());
	}
}

export default function* InfosWatcher() {
	yield takeEvery(Actions.types.GET_DELIVERY_INFO_DATA_START, getDeliveryInfoServiceWorker);
}
